import {createContext, useContext} from 'react';


export const CompanyContext = createContext();

export function useCompany() {
  return useContext(CompanyContext);
}

